import { IReactiveNewsContentItem } from "../SchoolFeedContentItem";
import { useStores } from "../../../stores/useStores";
import {
  buildContentItemUrl,
  isSchoolFeedStandalone,
} from "../../../utils/SchoolBlocksUtilities";
import { meritChatID } from "../../modals/NewsModal/NewsModalContent";
import { extractNumber } from "../../../utils/StringUtilities";
import ClickableLink from "../../utilities/ClickableLink";
import classNames from "classnames";
import styles from "./styles/ListItemGroup.module.scss";
import { TranslatedText } from "../../utilities/TranslatedText";
import { cssValue } from "../../../utils/SchoolBlocksUtilities";

export const JoinDiscussionButton = (props: {
  itemObj: IReactiveNewsContentItem;
  className?: string;
}) => {
  const { organizationStore } = useStores();
  const schoolFeedStandalone = isSchoolFeedStandalone();

  const schoolFeedLink = schoolFeedStandalone
    ? ""
    : organizationStore.organization.schoolfeed_hostname +
      buildContentItemUrl(props.itemObj.organization_id, props.itemObj.id);

  const handleClick = () => {
    // Need to delay scroll to account for modal transition time
    setTimeout(
      () => {
        const el = document.getElementById(meritChatID);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      },
      extractNumber(cssValue("--modal-transition-time")) + 250,
    );
  };

  return (
    <ClickableLink
      aria-label={"Link to content item page"}
      onClick={schoolFeedStandalone ? handleClick : (e) => e.stopPropagation()}
      href={schoolFeedLink}
      className={classNames(styles.joinTheDiscussion, props.className)}
    >
      <>
        <span className={styles.joinTheDiscussionFullText}>
          <TranslatedText i18nOptions={{ lng: props.itemObj.language }}>
            Join Discussion
          </TranslatedText>
        </span>
        <span className={styles.joinTheDiscussionShortText}>
          <TranslatedText i18nOptions={{ lng: props.itemObj.language }}>
            Discuss
          </TranslatedText>
        </span>
      </>
    </ClickableLink>
  );
};
